import { render } from "./VPagination.vue?vue&type=template&id=43c01335&scoped=true"
import script from "./VPagination.vue?vue&type=script&lang=js"
export * from "./VPagination.vue?vue&type=script&lang=js"

import "./VPagination.vue?vue&type=style&index=0&id=43c01335&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c01335"]])

export default __exports__